import axios from "axios";
import { useMutation, useQueryClient } from "react-query";

export const  useUploadReport =({report}) => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: async ({body,config}) => {
        //console.log("config in uploadReport is", config);
        return axios.post(`${process.env.REACT_APP_API_URI}UploadReport?report=${report}`, body,config).then((res) => res);
      }
  
    });
  }